<template>
  <form class="card-sakali"
        @submit.prevent="login">
    <div class="form-group">
      <label for="loginInput" class="col-form-label">Email</label>
      <input id="loginInput" type="text" class="form-control" v-model="email"
             autocomplete="username"/>
    </div>
    <div class="form-group">
      <label for="passwordInput" class="col-form-label">Passwort</label>
      <input id="passwordInput"
             type="password"
             class="form-control"
             v-model="password"
             autocomplete="current-password">
    </div>
    <div class="form-group pt-2">
      <button @click.prevent="login"
              class="btn form-control btn-sakali"
              :class="{'disabled':(!(email && password))}">
        Anmelden
      </button>
    </div>
  </form>
</template>

<script>

export default {
  data() {
    return {
      email: null,
      password: null
    }
  },
  methods: {
    login() {
      this.$store.dispatch('loginAction', {login: this.email, password: this.password});
    }
  }
}
</script>
